<template>
  <div class="animated fadeIn setting-container step-container" v-if="loaded">
    <div class="row">
      <div class="col-md-8 offset-md-2 alert-container-padding-zero">
        <alertbar/>
      </div>
    </div>
    <div class="row">
      <div class="col-md-8 offset-md-2 step-body">
        <h4 class="step-header">{{$t('message.settings.title')}}</h4>
        <h6>{{$t('message.settings.notification')}}</h6>

        <div class="row">
          <div class="col-12">
            
            <div class="form-group">
              
              <label class="switch switch-text switch-pill switch-success">
                <input type="checkbox" class="switch-input" v-model="clinic.sms_confirmation">
                <span class="switch-label" data-on="On" data-off="Off"></span>
                <span class="switch-handle"></span>
              </label>
              <label for="name">{{$t('message.settings.notify_when_appointment')}}</label>
            </div>
            <div class="form-divider"></div>
          </div>

          <div class="col-12">
            <div class="form-group">
              <label class="switch switch-text switch-pill switch-success">
                <input type="checkbox" class="switch-input" v-model="clinic.sms_active">
                <span class="switch-label" data-on="On" data-off="Off"></span>
                <span class="switch-handle"></span>
              </label>
              <label for="name">{{$t('message.settings.notify_sms')}}</label>
            </div>
          </div>

          <div class="col-1"></div>
          <div class="col-11">
            <div class="form-group">
              <label class="switch switch-text switch-pill switch-success">
                <input type="checkbox" class="switch-input" v-model="clinic.first_sms_reminder">
                <span class="switch-label" data-on="On" data-off="Off"></span>
                <span class="switch-handle"></span>
              </label>
              <label for="name">{{$t('message.settings.notify_before_one_day')}} {{$t('message.settings.time')}}</label>
              <vue-timepicker v-model="clinic.first_reminder_time_p"></vue-timepicker>
            </div>
          </div>

          <div class="col-1"></div>
          <div class="col-11">
            <div class="form-group">
              <label class="switch switch-text switch-pill switch-success">
                <input type="checkbox" class="switch-input" v-model="clinic.second_sms_reminder">
                <span class="switch-label" data-on="On" data-off="Off"></span>
                <span class="switch-handle"></span>
              </label>
              <label for="name">{{$t('message.settings.notify_appointment_day')}}</label>
            </div>
            
          </div>
          

          <div class="col-12">
            <div class="form-divider"></div>
            <div class="form-group">
              <label for="name">{{$t('message.settings.credit_remain')}}</label>
              <h4>{{clinic.sms_credit}}</h4>
            </div>
            <div class="form-divider"></div>
          </div>
        </div>

        <h6>การนัดหมาย Online</h6>

        <div class="row">

          <div class="col-12">
            <div class="form-group">
              <label class="switch switch-text switch-pill switch-success">
                <input type="checkbox" class="switch-input" v-model="clinic.appointment_active">
                <span class="switch-label" data-on="On" data-off="Off"></span>
                <span class="switch-handle"></span>
              </label>
              <label for="name">Online Appointment</label>
            </div>
          </div>

          <div class="col-12">
            <div class="form-group">
              <label class="switch switch-text switch-pill switch-success">
                <input type="checkbox" class="switch-input" v-model="clinic.instant_booking">
                <span class="switch-label" data-on="On" data-off="Off"></span>
                <span class="switch-handle"></span>
              </label>
              <label for="name">Instant Booking</label>
            </div>
          </div>

          <div class="col-12">
            <div class="form-group">
              <label class="switch switch-text switch-pill switch-success">
                <input type="checkbox" class="switch-input" v-model="clinic.instant_booking_sms_confirmation">
                <span class="switch-label" data-on="On" data-off="Off"></span>
                <span class="switch-handle"></span>
              </label>
              <label for="name">ส่ง SMS confirm เมื่อมี Instant Booking</label>
            </div>
          </div>

          <div class="col-12">
            <div class="form-group">
              <label class="switch switch-text switch-pill switch-success">
                <input type="checkbox" class="switch-input" v-model="clinic.forward_to_clinic_email">
                <span class="switch-label" data-on="On" data-off="Off"></span>
                <span class="switch-handle"></span>
              </label>
              <label for="name">{{$t('message.settings.new_appointment_fwd_to_mail')}}</label>
            </div>
          </div>

          

          <div class="col-12">
            <div class="form-group">
              <label for="name">Emails อื่นๆ (สำหรับการรับแจ้งเตือนนัดหมาย)</label>
              <doctor-single-input :dataset.sync="clinic.clinic_email"
                            @update:dataset="v => clinic.clinic_email = v"
                            :description="$t('message.settings.email')" />

              <doctor-array-input :dataset.sync="clinic.emails"
                            @update:dataset="v => clinic.emails = v"
                            :description="$t('message.settings.email')" />
            </div>
            <div class="form-divider"></div>
          </div>

          <div class="col-12">
            <div class="form-group">
              <label class="switch switch-text switch-pill switch-success">
                <input type="checkbox" class="switch-input" v-model="clinic.auto_match_ehr_patient">
                <span class="switch-label" data-on="On" data-off="Off"></span>
                <span class="switch-handle"></span>
              </label>
              <label for="name">{{$t('message.settings.auto_create_patient')}}</label>
            </div>
            <div class="form-divider"></div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 form-group">
            <button class="btn btn-store btn-lg" @click="save">{{$t('action_message.save')}}</button>
            <div slot='loader' v-show='loading' class='btn btn-sm'><sync-loader size='10px'></sync-loader></div>
          </div>
        </div>
      </div>
    </div>
    <sweet-modal icon="success" ref="modal"> </sweet-modal>
  </div>
</template>

<script>

import Alertbar from '@/components/AlertBar'
import SyncLoader from 'vue-spinner/src/SyncLoader'
import VueTimepicker from 'vue2-timepicker'
import { input as BsInput } from 'vue-strap'
import { SweetModal } from 'sweet-modal-vue'
import DoctorArrayInput from '@/components/DoctorArrayInput'
import DoctorSingleInput from '@/components/DoctorSingleInput'

export default {
  components: {
    Alertbar,
    SyncLoader,
    SweetModal,
    VueTimepicker,
    BsInput,
    DoctorArrayInput,
    DoctorSingleInput
  },
  data () {
    let clinicDefault = {
      sms_credit: 0,
      second_reminder_time_p: {
        HH: '08',
        mm: '00'
      },
      first_reminder_time_p: {
        HH: '08',
        mm: '00'
      }
    }
    return {
      clinic: Object.assign({}, clinicDefault),
      loading: true,
      loaded: false
    }
  },
  methods: {
    async loadSetting () {
      let response = await this.$http.get(this.$APP_CONFIG.api.admin.clinicme(this.$route, this.$guser), { credentials: true })
      if (response) {
        this.processClinic(response.body.data)
      }
      this.loading = false
      this.loaded = true
    },
    processClinic (data) {
      this.clinic = Object.assign({}, this.clinic, data)
      if (this.clinic.first_reminder_time) {
        let timeSplit = this.clinic.first_reminder_time.split(':')
        if (timeSplit.length > 1) {
          this.clinic = Object.assign({}, this.clinic, {
            first_reminder_time_p: {
              HH: timeSplit[0],
              mm: timeSplit[1]
            }
          })
        }
      }

      if (!this.clinic.emails || this.clinic.emails.length === 0) {
        this.clinic = Object.assign({}, this.clinic, {
          emails: []
        })
      }
    },
    save () {
      this.loading = true
      let updatedClinic = {
        sms_confirmation: this.clinic.sms_confirmation ? 1 : 0,
        email_confirmation: this.clinic.sms_confirmation ? 1 : 0,
        forward_to_clinic_email: this.clinic.forward_to_clinic_email ? 1 : 0,
        clinic_email: this.clinic.clinic_email,
        emails: this.clinic.emails,
        sms_active: this.clinic.sms_active ? 1 : 0,
        first_sms_reminder: this.clinic.first_sms_reminder ? 1 : 0,
        first_email_reminder: this.clinic.first_sms_reminder ? 1 : 0,
        second_sms_reminder: this.clinic.second_sms_reminder ? 1 : 0,
        second_email_reminder: this.clinic.second_sms_reminder ? 1 : 0,
        auto_match_ehr_patient: this.clinic.auto_match_ehr_patient ? 1 : 0,
        first_reminder_time: `${this.clinic.first_reminder_time_p.HH}:${this.clinic.first_reminder_time_p.mm},`,
        instant_booking: this.clinic.instant_booking,
        appointment_active: this.clinic.appointment_active,
        instant_booking_sms_confirmation: this.clinic.instant_booking_sms_confirmation
      }

      // Request URL
      this.$http.put(this.$APP_CONFIG.api.admin.clinicme(this.$route, this.$guser),
        updatedClinic,
        {headers: { 'content-type': 'application/json' }})
        .then(res => {
          this.loading = false
          if (res.body.status === 'success') {
            this.processClinic(res.body.data)
            this.$refs.modal.open()
          }
        })
    }
  },
  created () {
    this.loadSetting()
  }
}
</script>

<style lang="scss">
@import "../../assets/base_container";
.setting-container{
  .switch{
    margin-right: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// Setting.vue?39fd7d51